import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { GetRegistrationPackages, GetRegistrationPackagesResponse } from '../api/dtos';

const getData = (response?: SWRResponse<GetRegistrationPackagesResponse, GetRegistrationPackagesResponse>) => response?.data?.packages;

const getError = (response?: SWRResponse<GetRegistrationPackagesResponse, GetRegistrationPackagesResponse>) => (response?.error ?? response?.data)?.responseStatus;

const getAdditionalState = (response?: SWRResponse<GetRegistrationPackagesResponse, GetRegistrationPackagesResponse>) => ({
    packages: response?.data?.packages,
});


export const useAvailablePackages = (
    member?: number, 
    tc?: boolean, 
    std?: boolean, 
    reg?: boolean, 
    staff?: boolean, 
    attendeeFromJapanOrKorea?: boolean, 
    sponsor?: boolean, 
    freeSponsorRegistration?: boolean, 
    isSac?: boolean, 
    isCap?: boolean,
    isSpeaker?: boolean,
    isNextYearEarlyRegistration?: boolean,
    voucherId?: number,
    enteredDate?: string,
    configuration?: SWRConfiguration
) => {

    const request = useMemo(() => {

        return () => {
            return new GetRegistrationPackages({
                member, 
                restrictToTc: tc, 
                restrictToStudent: std, 
                restrictToRegistrar: reg, 
                staff, 
                attendeeFromJapanOrKorea, 
                sponsor, 
                freeSponsorRegistration, 
                isSac, 
                isCap,
                isSpeaker,
                isNextYearEarlyRegistration,
                voucherId: voucherId,
                enteredDate
            });
        };
    }, [member, tc, std, reg, staff, attendeeFromJapanOrKorea, sponsor, freeSponsorRegistration, isSac, isCap, isSpeaker, isNextYearEarlyRegistration, voucherId, enteredDate])

    return useGet(request, { getData, getError, getAdditionalState}, configuration);
};

export default useAvailablePackages;